import React from "react";

import {
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
} from "@teamrota/rota-design";

import {
  formatDateMonth,
  formatHoursMinutes,
  formatDateMonthTimeShort,
} from "~/src/utils/formatting";

import { EmptyText } from "~/src/components/payroll/style";
import { ScrollableTable } from "../styles";
import { COL_WIDTHS } from ".";

interface TableProps {
  fulfils: any[];
  loading: boolean;
}

const Table: React.FC<TableProps> = ({ fulfils, loading }) => {
  return (
    <ScrollableTable colWidths={COL_WIDTHS}>
      <THead>
        <TrHead>
          <Th>ID</Th>
          <Th>Client</Th>
          <Th>Venue</Th>
          <Th>Role</Th>
          <Th>Shift Date/Time</Th>
          <Th>Member</Th>
          <Th>Submitted</Th>
          <Th>Outcome</Th>
        </TrHead>
      </THead>

      <TBody className="streams-table-scroll-body">
        {!loading && fulfils?.length ? (
          fulfils.map((fulfil: any) => {
            const stream = fulfil?.stream;
            const shift = stream?.shift;

            return (
              <Tr key={fulfil.id}>
                <Td>
                  <InnerCell
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <span style={{ width: "4vw" }}>#{fulfil.id}</span>

                    {stream?.account?.provider && (
                      <img
                        title={stream?.account?.name}
                        src={`/images/shiftstream/${stream?.account?.provider}.png`}
                        alt={`${stream?.account?.provider} logo`}
                        style={{ height: 20, verticalAlign: "middle" }}
                      />
                    )}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {shift?.sourceAccount?.accountName || "-"}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {shift?.venue?.name || "-"}

                    {shift?.subvenue?.name && (
                      <div style={{ fontSize: "80%" }}>
                        ({shift?.subvenue?.name})
                      </div>
                    )}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>{shift?.role?.name || "-"}</InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    <div style={{ whiteSpace: "nowrap" }}>
                      {shift?.startTime
                        ? `${formatDateMonth(shift.startTime)}`
                        : "-"}
                    </div>

                    <div style={{ whiteSpace: "nowrap" }}>
                      {shift?.startTime
                        ? `${formatHoursMinutes(
                            shift.startTime,
                          )} - ${formatHoursMinutes(shift?.endTime)}`
                        : ""}
                    </div>
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {fulfil.member.firstName} {fulfil.member.lastName}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    <div>{formatDateMonthTimeShort(fulfil.createdAt)}</div>
                    <div>➡️ {fulfil.sourceId}</div>
                  </InnerCell>
                </Td>

                <Td>{getFillState(fulfil.state)}</Td>
              </Tr>
            );
          })
        ) : (
          <Tr>
            <Td colSpan={7}>
              <EmptyText>
                {!loading && "None found 👀"}
                {loading && "Loading... ⏳"}
              </EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </ScrollableTable>
  );
};

function getFillState(state: string) {
  switch (state) {
    case "SUBMITTED":
      return <span>Submitted ⌛️</span>;
    case "WON":
      return <span>Won ✅</span>;
    case "LOST":
      return <span>Lost ❌</span>;
    case "FAILED":
      return <span>Failed ⛔️</span>;
  }

  return <span>Unknown ⌛️</span>;
}

export default Table;
